/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'message': {
    width: 16,
    height: 16,
    viewBox: '0 0 23 23',
    data: '<path pid="0" d="M14.1 23v-2.6l6.4-6.4H23v2.6L16.6 23h-2.5zM15.3 0l5.1 5.1h-5.1V0z" _fill="#757e8d"/><path pid="1" d="M14.1 6.4V0H2.6C1.1 0 0 1.1 0 2.6v16.6c0 1.4 1.1 2.6 2.6 2.6h7.7l10.2-10.2V6.4h-6.4zm-2.6 6.9H3.8v-1h7.7v1zm0-3.9H3.8v-1h7.7v1z" _fill="#757e8d"/>'
  }
})
